import { httpClient } from './httpClient';
import type { GetActionLogsResponse } from './types';

interface QueryOptions {
    signal?: AbortSignal;
}

export const actionLogsApi = {
    listForClient: (clientId: string, options?: QueryOptions): Promise<GetActionLogsResponse> => {
        return httpClient.get<GetActionLogsResponse>(
            `/v1/clients/${clientId}/activity-log`,
            options
        );
    },
} as const;
